// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/payments.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/payments.proto.
 */
export const file_cortado_v1_payments: GenFile = /*@__PURE__*/
  fileDesc("Chljb3J0YWRvL3YxL3BheW1lbnRzLnByb3RvEgpjb3J0YWRvLnYxIpUCCg1TdHJpcGVBY2NvdW50EgoKAmlkGAEgASgJEgwKBHR5cGUYAiABKAkSFwoPY2hhcmdlc19lbmFibGVkGAMgASgIEhcKD3BheW91dHNfZW5hYmxlZBgEIAEoCBIZChFkZXRhaWxzX3N1Ym1pdHRlZBgFIAEoCBIzCgpjcmVhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEjMKCnVwZGF0ZWRfYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESFQoNYnVzaW5lc3NfbmFtZRgIIAEoCUINCgtfY3JlYXRlZF9hdEINCgtfdXBkYXRlZF9hdCI7CiBHZXRTdHJpcGVDb25uZWN0aW9uU3RhdHVzUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkidgohR2V0U3RyaXBlQ29ubmVjdGlvblN0YXR1c1Jlc3BvbnNlEhQKDGlzX2Nvbm5lY3RlZBgBIAEoCBIvCgdhY2NvdW50GAIgASgLMhkuY29ydGFkby52MS5TdHJpcGVBY2NvdW50SACIAQFCCgoIX2FjY291bnQiOQoeR2V0U3RyaXBlQWNjb3VudExpbmtVUkxSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCSJCCh9HZXRTdHJpcGVBY2NvdW50TGlua1VSTFJlc3BvbnNlEgsKA3VybBgBIAEoCRISCgphY2NvdW50X2lkGAIgASgJIjkKHkRpc2Nvbm5lY3RTdHJpcGVBY2NvdW50UmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkiMgofRGlzY29ubmVjdFN0cmlwZUFjY291bnRSZXNwb25zZRIPCgdtZXNzYWdlGAEgASgJIvIBCg1TdHJpcGVXZWJob29rEhAKCGV2ZW50X2lkGAEgASgJEhIKCmV2ZW50X3R5cGUYAiABKAkSEQoJb2JqZWN0X2lkGAMgASgJEhYKDndlYmhvb2tfc3RhdHVzGAQgASgJEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhwKD29yZ2FuaXphdGlvbl9pZBgHIAEoCUgAiAEBQhIKEF9vcmdhbml6YXRpb25faWQiQwoZTGlzdEZhaWxlZFdlYmhvb2tzUmVxdWVzdBINCgVsaW1pdBgBIAEoBRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkiXgoaTGlzdEZhaWxlZFdlYmhvb2tzUmVzcG9uc2USKwoId2ViaG9va3MYASADKAsyGS5jb3J0YWRvLnYxLlN0cmlwZVdlYmhvb2sSEwoLdG90YWxfY291bnQYAiABKAUiWQoYTGlzdFN0YWxlV2ViaG9va3NSZXF1ZXN0EhUKDXN0YWxlX21pbnV0ZXMYASABKAUSDQoFbGltaXQYAiABKAUSFwoPb3JnYW5pemF0aW9uX2lkGAMgASgJIl0KGUxpc3RTdGFsZVdlYmhvb2tzUmVzcG9uc2USKwoId2ViaG9va3MYASADKAsyGS5jb3J0YWRvLnYxLlN0cmlwZVdlYmhvb2sSEwoLdG90YWxfY291bnQYAiABKAUiPQoTTGlzdFdlYmhvb2tzUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkSDQoFbGltaXQYAiABKAUiWAoUTGlzdFdlYmhvb2tzUmVzcG9uc2USKwoId2ViaG9va3MYASADKAsyGS5jb3J0YWRvLnYxLlN0cmlwZVdlYmhvb2sSEwoLdG90YWxfY291bnQYAiABKAUiQQoUUmVwbGF5V2ViaG9va1JlcXVlc3QSEAoIZXZlbnRfaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJIk4KFVJlcGxheVdlYmhvb2tSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIEg8KB21lc3NhZ2UYAiABKAkSEwoLd29ya2Zsb3dfaWQYAyABKAkiRQobUmVwbGF5RmFpbGVkV2ViaG9va3NSZXF1ZXN0Eg0KBWxpbWl0GAEgASgFEhcKD29yZ2FuaXphdGlvbl9pZBgCIAEoCSJvChxSZXBsYXlGYWlsZWRXZWJob29rc1Jlc3BvbnNlEhYKDnJlcGxheWVkX2NvdW50GAEgASgFEhQKDGZhaWxlZF9jb3VudBgCIAEoBRIRCglldmVudF9pZHMYAyADKAkSDgoGZXJyb3JzGAQgAygJIlsKGlJlcGxheVN0YWxlV2ViaG9va3NSZXF1ZXN0EhUKDXN0YWxlX21pbnV0ZXMYASABKAUSDQoFbGltaXQYAiABKAUSFwoPb3JnYW5pemF0aW9uX2lkGAMgASgJIm4KG1JlcGxheVN0YWxlV2ViaG9va3NSZXNwb25zZRIWCg5yZXBsYXllZF9jb3VudBgBIAEoBRIUCgxmYWlsZWRfY291bnQYAiABKAUSEQoJZXZlbnRfaWRzGAMgAygJEg4KBmVycm9ycxgEIAMoCUImWiRodWItYmFja2VuZC9nZW4vY29ydGFkby92MTtjb3J0YWRvdjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * StripeAccount represents a Stripe Connected Account
 *
 * @generated from message cortado.v1.StripeAccount
 */
export type StripeAccount = Message<"cortado.v1.StripeAccount"> & {
  /**
   * stripe_account_id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "standard" or "express"
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * Can accept payments
   *
   * @generated from field: bool charges_enabled = 3;
   */
  chargesEnabled: boolean;

  /**
   * Can receive payouts
   *
   * @generated from field: bool payouts_enabled = 4;
   */
  payoutsEnabled: boolean;

  /**
   * Onboarding complete
   *
   * @generated from field: bool details_submitted = 5;
   */
  detailsSubmitted: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * Business or display name from Stripe
   *
   * @generated from field: string business_name = 8;
   */
  businessName: string;
};

/**
 * Describes the message cortado.v1.StripeAccount.
 * Use `create(StripeAccountSchema)` to create a new message.
 */
export const StripeAccountSchema: GenMessage<StripeAccount> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 0);

/**
 * GetStripeConnectionStatus checks if Stripe is connected
 *
 * @generated from message cortado.v1.GetStripeConnectionStatusRequest
 */
export type GetStripeConnectionStatusRequest = Message<"cortado.v1.GetStripeConnectionStatusRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetStripeConnectionStatusRequest.
 * Use `create(GetStripeConnectionStatusRequestSchema)` to create a new message.
 */
export const GetStripeConnectionStatusRequestSchema: GenMessage<GetStripeConnectionStatusRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 1);

/**
 * @generated from message cortado.v1.GetStripeConnectionStatusResponse
 */
export type GetStripeConnectionStatusResponse = Message<"cortado.v1.GetStripeConnectionStatusResponse"> & {
  /**
   * @generated from field: bool is_connected = 1;
   */
  isConnected: boolean;

  /**
   * @generated from field: optional cortado.v1.StripeAccount account = 2;
   */
  account?: StripeAccount;
};

/**
 * Describes the message cortado.v1.GetStripeConnectionStatusResponse.
 * Use `create(GetStripeConnectionStatusResponseSchema)` to create a new message.
 */
export const GetStripeConnectionStatusResponseSchema: GenMessage<GetStripeConnectionStatusResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 2);

/**
 * GetStripeAccountLinkURL creates/returns account link URL for onboarding
 *
 * @generated from message cortado.v1.GetStripeAccountLinkURLRequest
 */
export type GetStripeAccountLinkURLRequest = Message<"cortado.v1.GetStripeAccountLinkURLRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetStripeAccountLinkURLRequest.
 * Use `create(GetStripeAccountLinkURLRequestSchema)` to create a new message.
 */
export const GetStripeAccountLinkURLRequestSchema: GenMessage<GetStripeAccountLinkURLRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 3);

/**
 * @generated from message cortado.v1.GetStripeAccountLinkURLResponse
 */
export type GetStripeAccountLinkURLResponse = Message<"cortado.v1.GetStripeAccountLinkURLResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * For frontend tracking
   *
   * @generated from field: string account_id = 2;
   */
  accountId: string;
};

/**
 * Describes the message cortado.v1.GetStripeAccountLinkURLResponse.
 * Use `create(GetStripeAccountLinkURLResponseSchema)` to create a new message.
 */
export const GetStripeAccountLinkURLResponseSchema: GenMessage<GetStripeAccountLinkURLResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 4);

/**
 * DisconnectStripeAccount removes Stripe connection
 *
 * @generated from message cortado.v1.DisconnectStripeAccountRequest
 */
export type DisconnectStripeAccountRequest = Message<"cortado.v1.DisconnectStripeAccountRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.DisconnectStripeAccountRequest.
 * Use `create(DisconnectStripeAccountRequestSchema)` to create a new message.
 */
export const DisconnectStripeAccountRequestSchema: GenMessage<DisconnectStripeAccountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 5);

/**
 * @generated from message cortado.v1.DisconnectStripeAccountResponse
 */
export type DisconnectStripeAccountResponse = Message<"cortado.v1.DisconnectStripeAccountResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DisconnectStripeAccountResponse.
 * Use `create(DisconnectStripeAccountResponseSchema)` to create a new message.
 */
export const DisconnectStripeAccountResponseSchema: GenMessage<DisconnectStripeAccountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 6);

/**
 * StripeWebhook represents a stored Stripe webhook event
 *
 * @generated from message cortado.v1.StripeWebhook
 */
export type StripeWebhook = Message<"cortado.v1.StripeWebhook"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string event_type = 2;
   */
  eventType: string;

  /**
   * @generated from field: string object_id = 3;
   */
  objectId: string;

  /**
   * Pending, Processing, Completed, Failed
   *
   * @generated from field: string webhook_status = 4;
   */
  webhookStatus: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * Organization this webhook belongs to (may be null for legacy/external webhooks)
   *
   * @generated from field: optional string organization_id = 7;
   */
  organizationId?: string;
};

/**
 * Describes the message cortado.v1.StripeWebhook.
 * Use `create(StripeWebhookSchema)` to create a new message.
 */
export const StripeWebhookSchema: GenMessage<StripeWebhook> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 7);

/**
 * ListFailedWebhooksRequest retrieves failed webhooks for potential replay
 *
 * @generated from message cortado.v1.ListFailedWebhooksRequest
 */
export type ListFailedWebhooksRequest = Message<"cortado.v1.ListFailedWebhooksRequest"> & {
  /**
   * Maximum number of webhooks to return (default 100)
   *
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * Required: filter by organization
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListFailedWebhooksRequest.
 * Use `create(ListFailedWebhooksRequestSchema)` to create a new message.
 */
export const ListFailedWebhooksRequestSchema: GenMessage<ListFailedWebhooksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 8);

/**
 * @generated from message cortado.v1.ListFailedWebhooksResponse
 */
export type ListFailedWebhooksResponse = Message<"cortado.v1.ListFailedWebhooksResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.StripeWebhook webhooks = 1;
   */
  webhooks: StripeWebhook[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListFailedWebhooksResponse.
 * Use `create(ListFailedWebhooksResponseSchema)` to create a new message.
 */
export const ListFailedWebhooksResponseSchema: GenMessage<ListFailedWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 9);

/**
 * ListStaleWebhooksRequest retrieves pending webhooks older than specified duration
 *
 * @generated from message cortado.v1.ListStaleWebhooksRequest
 */
export type ListStaleWebhooksRequest = Message<"cortado.v1.ListStaleWebhooksRequest"> & {
  /**
   * Webhooks pending for longer than this are considered stale (default 30)
   *
   * @generated from field: int32 stale_minutes = 1;
   */
  staleMinutes: number;

  /**
   * Maximum number of webhooks to return (default 100)
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * Required: filter by organization
   *
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListStaleWebhooksRequest.
 * Use `create(ListStaleWebhooksRequestSchema)` to create a new message.
 */
export const ListStaleWebhooksRequestSchema: GenMessage<ListStaleWebhooksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 10);

/**
 * @generated from message cortado.v1.ListStaleWebhooksResponse
 */
export type ListStaleWebhooksResponse = Message<"cortado.v1.ListStaleWebhooksResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.StripeWebhook webhooks = 1;
   */
  webhooks: StripeWebhook[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListStaleWebhooksResponse.
 * Use `create(ListStaleWebhooksResponseSchema)` to create a new message.
 */
export const ListStaleWebhooksResponseSchema: GenMessage<ListStaleWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 11);

/**
 * ListWebhooksRequest retrieves all webhooks for an organization
 *
 * @generated from message cortado.v1.ListWebhooksRequest
 */
export type ListWebhooksRequest = Message<"cortado.v1.ListWebhooksRequest"> & {
  /**
   * Required: filter by organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Maximum number of webhooks to return (default 100)
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message cortado.v1.ListWebhooksRequest.
 * Use `create(ListWebhooksRequestSchema)` to create a new message.
 */
export const ListWebhooksRequestSchema: GenMessage<ListWebhooksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 12);

/**
 * @generated from message cortado.v1.ListWebhooksResponse
 */
export type ListWebhooksResponse = Message<"cortado.v1.ListWebhooksResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.StripeWebhook webhooks = 1;
   */
  webhooks: StripeWebhook[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListWebhooksResponse.
 * Use `create(ListWebhooksResponseSchema)` to create a new message.
 */
export const ListWebhooksResponseSchema: GenMessage<ListWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 13);

/**
 * ReplayWebhookRequest replays a single webhook by event ID
 *
 * @generated from message cortado.v1.ReplayWebhookRequest
 */
export type ReplayWebhookRequest = Message<"cortado.v1.ReplayWebhookRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * Required: webhook must belong to this org
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ReplayWebhookRequest.
 * Use `create(ReplayWebhookRequestSchema)` to create a new message.
 */
export const ReplayWebhookRequestSchema: GenMessage<ReplayWebhookRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 14);

/**
 * @generated from message cortado.v1.ReplayWebhookResponse
 */
export type ReplayWebhookResponse = Message<"cortado.v1.ReplayWebhookResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Temporal workflow ID if started
   *
   * @generated from field: string workflow_id = 3;
   */
  workflowId: string;
};

/**
 * Describes the message cortado.v1.ReplayWebhookResponse.
 * Use `create(ReplayWebhookResponseSchema)` to create a new message.
 */
export const ReplayWebhookResponseSchema: GenMessage<ReplayWebhookResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 15);

/**
 * ReplayFailedWebhooksRequest replays all failed webhooks (or up to limit)
 *
 * @generated from message cortado.v1.ReplayFailedWebhooksRequest
 */
export type ReplayFailedWebhooksRequest = Message<"cortado.v1.ReplayFailedWebhooksRequest"> & {
  /**
   * Maximum number of webhooks to replay (default 100)
   *
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * Required: only replay webhooks for this org
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ReplayFailedWebhooksRequest.
 * Use `create(ReplayFailedWebhooksRequestSchema)` to create a new message.
 */
export const ReplayFailedWebhooksRequestSchema: GenMessage<ReplayFailedWebhooksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 16);

/**
 * @generated from message cortado.v1.ReplayFailedWebhooksResponse
 */
export type ReplayFailedWebhooksResponse = Message<"cortado.v1.ReplayFailedWebhooksResponse"> & {
  /**
   * @generated from field: int32 replayed_count = 1;
   */
  replayedCount: number;

  /**
   * @generated from field: int32 failed_count = 2;
   */
  failedCount: number;

  /**
   * Event IDs that were replayed
   *
   * @generated from field: repeated string event_ids = 3;
   */
  eventIds: string[];

  /**
   * Error messages for failed replays
   *
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];
};

/**
 * Describes the message cortado.v1.ReplayFailedWebhooksResponse.
 * Use `create(ReplayFailedWebhooksResponseSchema)` to create a new message.
 */
export const ReplayFailedWebhooksResponseSchema: GenMessage<ReplayFailedWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 17);

/**
 * ReplayStaleWebhooksRequest replays all stale pending webhooks
 *
 * @generated from message cortado.v1.ReplayStaleWebhooksRequest
 */
export type ReplayStaleWebhooksRequest = Message<"cortado.v1.ReplayStaleWebhooksRequest"> & {
  /**
   * Webhooks pending for longer than this (default 30)
   *
   * @generated from field: int32 stale_minutes = 1;
   */
  staleMinutes: number;

  /**
   * Maximum number of webhooks to replay (default 100)
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * Required: only replay webhooks for this org
   *
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ReplayStaleWebhooksRequest.
 * Use `create(ReplayStaleWebhooksRequestSchema)` to create a new message.
 */
export const ReplayStaleWebhooksRequestSchema: GenMessage<ReplayStaleWebhooksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 18);

/**
 * @generated from message cortado.v1.ReplayStaleWebhooksResponse
 */
export type ReplayStaleWebhooksResponse = Message<"cortado.v1.ReplayStaleWebhooksResponse"> & {
  /**
   * @generated from field: int32 replayed_count = 1;
   */
  replayedCount: number;

  /**
   * @generated from field: int32 failed_count = 2;
   */
  failedCount: number;

  /**
   * @generated from field: repeated string event_ids = 3;
   */
  eventIds: string[];

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];
};

/**
 * Describes the message cortado.v1.ReplayStaleWebhooksResponse.
 * Use `create(ReplayStaleWebhooksResponseSchema)` to create a new message.
 */
export const ReplayStaleWebhooksResponseSchema: GenMessage<ReplayStaleWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_payments, 19);

